import get from 'lodash/get';
import { GetFareCalendarAction } from 'actions/TravelActions/FareCalendarActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
export const defaultState = {
    asyncStatus: AsyncStatus.INIT
};
export default function FareCalendarReducer(state = defaultState, action) {
    switch (action.type) {
        case GetFareCalendarAction.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case GetFareCalendarAction.SUCCESS: {
            const fareCalendarData = get(action.data, 'fares.value');
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.SUCCESS,
                requestedQuery: action.requestedQuery,
                fareCalendarData
            });
        }
        case GetFareCalendarAction.ERROR: {
            return Object.assign({}, { asyncStatus: AsyncStatus.ERROR }, action.error);
        }
        default:
            return state;
    }
}
